import React, { useEffect, useState } from 'react';
import Banner from '../../components/Banner';
import styles from '../../css/ourCompany.module.css';
import ourCompanyBanner from '../../assets/images/our-company-banner.png';
import membersHerbert from '../../assets/images/herbert.png';
import membersEnrique from '../../assets/images/enrique.png';
import membersMiles from '../../assets/images/Miles.png';
import membersAdrian from '../../assets/images/Adrian.png';
import membershipLogo1 from '../../assets/images/dot.png';
import membershipLogo2 from '../../assets/images/ccci-logo.png';
import membershipLogo3 from '../../assets/images/European-Chamber-of-Commerce-of-the-Philippines-ECCP.png';
import membershipLogo4 from '../../assets/images/HRRAC.png';
import section2OurCompany from '../../assets/images/section-2-our-company.png';

const OurCompany = () => {
  return (
    <div className="main-container">
      <Banner
        image={ourCompanyBanner}
        altText="Our Company Banner"
        className="our-company-banner">

      </Banner>
  
        <section className={styles.section1}>
          <div className="container">
            <p className="comp-desc">HiveRooms is more than just a hospitality technology solution; it’s now a travel marketplace
              where you can book your accommodations, travel experiences, and events in one platform.</p>
          </div>
        </section>

        <section className={styles.section2}>
            <div className="comp-categories">
              <ul>
                <li><a href="#our-story">Our Story</a></li>
                <li><a href="#meet-team">Meet the Team</a></li>
                <li><a href="#membership">Membership and Accreditation</a></li>
                <li><a href="#who-trust">Who Trust Us</a></li>
              </ul>
            </div>
          <div className="container">
            <div className="banner">
              <img src={section2OurCompany} alt="" />
            </div>
          </div>
        </section>

        <section id="our-story" className={styles.section3}>
          <div className="container">
            <h2 className="title-heading">Our Story</h2>
            <h3 className="sub-heading">HiveRooms: Empowering Local Communities Through Purposeful Tourism</h3>
            <p className="desc">HiveRooms, a proud Filipino brand, offers digital and management solutions for the travel and hospitality sector. We
              blend smart technology with immersive, educational tour packages to create meaningful experiences that connect
              travelers with the unique people, culture, and traditions of the Philippines, starting in Cebu and expanding nationwide.
              <br></br><br></br>
              Our core mission is to boost local businesses and foster inclusive growth in tourism. We achieve this through strategic
              partnerships and community-driven initiatives, empowering grassroots organizations. We help them gain visibility,
              increase profitability, and share their compelling stories with a wider audience. Our community development efforts
              champion sustainable tourism by working closely with diverse coastal and upland communities. These collaborations
              not only enrich traveler experiences but also ensure that the economic benefits of tourism reach local communities.
              <br></br><br></br>
              A highlight of our pilot immersive offerings, developed in partnership with the Cebu Chamber of Commerce and
              Industry (CCCI) through their AFOS-Foundation Fish Visayas project, the Municipality of Cordova, Cebu, and
              Seed4Com, is "Fisherman-for-a-Day" in Cordova, Cebu. This hands-on activity invites travelers to experience the daily
              life of a local fisherman, learning traditional techniques, understanding their role in the marine ecosystem, and
              appreciating their vital place in Cebuano culture.
              <br></br><br></br>
              In Bantayan Island, we're privileged to partner with the Women Association of Basawon (WAB) and the Seaweed
              Cracker Makers of Luyong Baybay, also with CCCI. These partnerships showcase the creativity, resilience, and heritage
              of local women, transforming each visit into an opportunity for cultural appreciation and economic support.
              HiveRooms champions a tourism model deeply rooted in community, experience, and sustainability. Through our
              corporate social responsibility efforts, we strive to make every journey impactful, benefiting both travelers and the
              communities that graciously welcome them.
              <br></br><br></br>
              Together, let’s redefine tourism, where every interaction, every story, and every step supports a stronger, more
              inclusive Philippines.
              </p>
          </div>
        </section>

        <section id="meet-team" className={styles.section4}>
          <div className="container">
            <h2 className="title-heading">Meet The Team</h2>
            <div className={styles.members}>
              <div className={styles.member}>
                <img src={membersHerbert} alt="CEO HERBERT DIONZON" />
                <p className={styles.name}><b>Herbert Dionzon</b><br></br>
                    FOUNDER AND CEO</p>
              </div>
              <div className={styles.member}>
                <img src={membersEnrique} alt="CO Founder and VP BUSINESS DEVELOPMENT  ENRIQUE SAN JUAN" />
                <p className={styles.name}><b>Enrique San Juan</b><br></br>
                    CO Founder and VP BUSINESS DEVELOPMENT</p>
              </div>
              <div className={styles.member}>
                <img src={membersMiles} alt="Miles Cañada" />
                <p className={styles.name}><b>Miles Cañada</b><br></br>
                    Coordinator</p>
              </div>
              <div className={styles.member}>
                <img src={membersAdrian} alt="Client Success Manager" />
                <p className={styles.name}><b>Adrian Yanos</b><br></br>
                    Client Success Manager</p>
              </div>
            </div>
          </div>
        </section>

        <section id="membership" className={styles.section5}>
          <div className="container">
            <h2 className="title-heading">Membership and Accreditations</h2>
            <div className={styles.logos}>
              <div className={styles.logo}>
                <img src={membershipLogo1} alt="DOT" />
                <p className={styles.name}><b>DOT Accredited</b></p>
              </div>
              <div className={styles.logo}>
                <img src={membershipLogo2} alt="DOT" />
                <p className={styles.name}><b>Cebu Chamber of Commerce and Industry</b></p>
              </div>
              <div className={styles.logo}>
                <img src={membershipLogo3} alt="DOT" />
                <p className={styles.name}><b>European Chamber of Commerce of the Philippines</b></p>
              </div>
              <div className={styles.logo}>
                <img src={membershipLogo4} alt="DOT" />
                <p className={styles.name}><b>Hotel Resort & Restaurant Association of Cebu Inc.</b></p>
              </div>
            </div>

          </div>
        </section>

        <section id="who-trust" className={styles.section6}>
          <div className="container">
            <h2 className="title-heading">Who Trust Us</h2>
            <div className={styles.partners}>
              <table>
                <tr>
                  <td>8 Newtown Boulevard</td>
                  <td>MCA Suites</td>
                </tr>
                <tr>
                  <td>One Manchester Place</td>
                  <td>Mandala Beach Cebu</td>
                </tr>
                <tr>
                  <td>One Pacific Residences</td>
                  <td>Northomes Pensione</td>
                </tr>
                <tr>
                  <td>Almond Suites</td>
                  <td>Rajah Park Hotel</td>
                </tr>
                <tr>
                  <td>Ariella Mangrove &amp; Eco Resort</td>
                  <td>Rockwalled Adventure Resort</td>
                </tr>
                <tr>
                  <td>Bluewaves Basdaku</td>
                  <td>Serenity Farm and Resort</td>
                </tr>
                <tr>
                  <td>Bluewaves Hostel &amp; Villa Panagsama</td>
                  <td>Australia Serenity Home 11</td>
                </tr>
                <tr>
                  <td>Casa De Vacaccion in Orani, Bataan</td>
                  <td>Australia Serenity Home 7</td>
                </tr>
                <tr>
                  <td>Casay Beach Huts</td>
                  <td>Australia Serenity Home 9</td>
                </tr>
                <tr>
                  <td>Ceda Guest House</td>
                  <td>Sonrisa Resort de Playa</td>
                </tr>
                <tr>
                  <td>F and C Guest House</td>
                  <td>Sonrisa Golden Meadows</td>
                </tr>
                <tr>
                  <td>Fazenda De Faburada Eco Farm and Mountain Resort</td>
                  <td>Upperhouse Hotel, formerly Pacifico Boutique Hotel</td>
                </tr>
                <tr>
                  <td>Fins Pacific Coral Bay</td>
                  <td>Teofel Hostel</td>
                </tr>
                <tr>
                  <td>Hagdan Reef Dive Spot</td>
                  <td>Kalaparan Farm House</td>
                </tr>
                <tr>
                  <td>Harmonia Nature Resort</td>
                  <td>Maayo Hotel and Resorts</td>
                </tr>
                <tr>
                  <td>iPark Hotel</td>
                  <td>Tambuli Seaside Living</td>
                </tr>
                <tr>
                  <td>JVR Island In the Sky Resort</td>
                  <td>The Reef Island Resort</td>
                </tr>
              </table>
            </div>
          </div>
        </section>
    </div>
  );
};

export default OurCompany;